import { userAxios } from "../index";

/**
 * Servicio para gestionar la información de pago de los agentes de seguros.
 */

/**
 * Guardar los datos del formulario de información de pago
 * @param {Object} payload - Datos del formulario
 * @returns {Promise}
 */
const createPaymentInfo = async (payload) =>
  userAxios
    .post("/payment-to-agents", payload)
    .then((response) => response.data);

/**
 * Obtener la información de pago de un agente
 * @param {Number} agentId - ID del agente
 * @returns {Promise}
 */
const getPaymentInfo = async (agentId) =>
  userAxios
    .get(`/payment-to-agents/${agentId}`)
    .then((response) => response.data);

/**
 * Actualizar los datos del formulario de información de pago
 * @param {Number} formId - ID del formulario
 * @param {Object} payload - Datos actualizados
 * @returns {Promise}
 */
const updatePaymentInfo = async (formId, payload) =>
  userAxios
    .put(`/payment-to-agents/${formId}`, payload)
    .then((response) => response.data);

export default {
  createPaymentInfo,
  getPaymentInfo,
  updatePaymentInfo,
};

